import CampaignManagementTypes from './campaignManagement.types';
import AnyAction from 'store/anyActions';
import CampaignManagementState, { CampaignsState, UploadFile } from './campaignManagement.state';
import { combineReducers } from 'redux';

const defaultState: CampaignsState = null;

const campaignsReducer = function (state: CampaignsState = defaultState, action: AnyAction): CampaignsState {
	switch (action.type) {
		case CampaignManagementTypes.GET_CAMPAIGNS_SUCCESS:
			return [...action.payload];
		case CampaignManagementTypes.GET_CAMPAIGNS_FAILURE:
			return state ? [...state] : [];
		case CampaignManagementTypes.CREATE_CAMPAIGN_SUCCESS:
			return [action.payload, ...state || []];
		default:
			return state;
	}
}


const uploadReducer = function (state: UploadFile = {}, action: AnyAction): UploadFile {
	switch (action.type) {
		case CampaignManagementTypes.CREATE_S3URL_FAILURE:
			return { ...state, error: action.payload };
		case CampaignManagementTypes.CREATE_S3URL_SUCCESS:
			return { ...state, ...action.payload };
		case CampaignManagementTypes.CREATE_S3URL_UPLOADING:
			return { ...state, uploading: action.payload, error: false };
		case CampaignManagementTypes.REMOVE_S3URL_UPLOADING:
			return {};
		default:
			return state;
	}
}

const isCreatingReducer = function (state: boolean = false, action: AnyAction): boolean {
	switch (action.type) {
		case CampaignManagementTypes.CREATE_CAMPAIGN:
		case CampaignManagementTypes.EDIT_CAMPAIGN:
			return true;
		case CampaignManagementTypes.CREATE_CAMPAIGN_SUCCESS:
		case CampaignManagementTypes.CREATE_CAMPAIGN_FAILURE:
		case CampaignManagementTypes.EDIT_CAMPAIGN_SUCCESS:
		case CampaignManagementTypes.EDIT_CAMPAIGN_FAILURE:
			return false;
		default:
			return state;
	}
}

const campaignManagementReducer = combineReducers<CampaignManagementState>({
	campaigns: campaignsReducer,
	s3Url: uploadReducer,
	isCreating: isCreatingReducer
});

export default campaignManagementReducer;
